
import { Brandmark } from '@client/shared/design';
import styles from './AppStates.module.css';

export function Splash({ label = 'Loading your schedule…' }: { label?: string }) {
  return (
    <div className={styles.center}>
      <div className={styles.splashInner}>
        <Brandmark size={56} className={styles.pulse} />
        <span className={styles.splashWord}>{label}</span>
      </div>
    </div>
  );
}
